interface Props extends React.SVGProps<SVGSVGElement> {
  size?: string;
}

export default function Email({ size = "16", ...props }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      {...props}
    >
      <g opacity="0.5">
        <path
          d="M0.05 4.055C0.150818 3.61324 0.398655 3.21881 0.752922 2.93631C1.10719 2.6538 1.54688 2.49997 2 2.5H14C14.4531 2.49997 14.8928 2.6538 15.2471 2.93631C15.6013 3.21881 15.8492 3.61324 15.95 4.055L8 8.914L0.05 4.055ZM0 5.197V12.301L5.803 8.743L0 5.197ZM6.761 9.33L0.191 13.357C0.353327 13.6993 0.609527 13.9884 0.929782 14.1908C1.25004 14.3931 1.62117 14.5004 2 14.5H14C14.3788 14.5001 14.7498 14.3926 15.0698 14.1901C15.3899 13.9876 15.6459 13.6983 15.808 13.356L9.238 9.329L8 10.086L6.761 9.33ZM10.197 8.744L16 12.301V5.197L10.197 8.743V8.744Z"
          fill="#061425"
        />
      </g>
    </svg>
  );
}
